// GENERATED - do not hand-edit. Rebuild: node frontend/scripts/generateRcraCatalogue.mjs
// @source 40 CFR Part 261 via eCFR Versioner API (https://www.ecfr.gov/api/versioner/v1/full/2026-06-30/title-40.xml?part=261)
// Generated 2026-07-03. 562 codes.
import type { RcraEntry } from './rcraCatalogue';

export const RCRA_GENERATED: RcraEntry[] = [
  {
    "code": "D001",
    "list": "D",
    "hazardBasis": "ignitable",
    "description": "Ignitable waste - liquids with flash point below 60 C (140 F), ignitable solids, oxidizers, and ignitable compressed gases",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.21",
    "codeSlug": "d001"
  },
  {
    "code": "D002",
    "list": "D",
    "hazardBasis": "corrosive",
    "description": "Corrosive waste - aqueous wastes with pH at or below 2 or at or above 12.5, or liquids that corrode steel faster than 6.35 mm per year",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.22",
    "codeSlug": "d002"
  },
  {
    "code": "D003",
    "list": "D",
    "hazardBasis": "reactive",
    "description": "Reactive waste - unstable, water-reactive, cyanide- or sulfide-bearing, or explosive wastes",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.23",
    "codeSlug": "d003"
  },
  {
    "code": "D004",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Arsenic at or above 5.0 mg/L (TCLP)",
    "contaminant": "Arsenic",
    "regulatoryLevel": "5.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d004"
  },
  {
    "code": "D005",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Barium at or above 100.0 mg/L (TCLP)",
    "contaminant": "Barium",
    "regulatoryLevel": "100.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d005"
  },
  {
    "code": "D006",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Cadmium at or above 1.0 mg/L (TCLP)",
    "contaminant": "Cadmium",
    "regulatoryLevel": "1.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d006"
  },
  {
    "code": "D007",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Chromium at or above 5.0 mg/L (TCLP)",
    "contaminant": "Chromium",
    "regulatoryLevel": "5.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d007"
  },
  {
    "code": "D008",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Lead at or above 5.0 mg/L (TCLP)",
    "contaminant": "Lead",
    "regulatoryLevel": "5.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d008"
  },
  {
    "code": "D009",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Mercury at or above 0.2 mg/L (TCLP)",
    "contaminant": "Mercury",
    "regulatoryLevel": "0.2 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d009"
  },
  {
    "code": "D010",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Selenium at or above 1.0 mg/L (TCLP)",
    "contaminant": "Selenium",
    "regulatoryLevel": "1.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d010"
  },
  {
    "code": "D011",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Silver at or above 5.0 mg/L (TCLP)",
    "contaminant": "Silver",
    "regulatoryLevel": "5.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d011"
  },
  {
    "code": "D012",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Endrin at or above 0.02 mg/L (TCLP)",
    "contaminant": "Endrin",
    "regulatoryLevel": "0.02 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d012"
  },
  {
    "code": "D013",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Lindane at or above 0.4 mg/L (TCLP)",
    "contaminant": "Lindane",
    "regulatoryLevel": "0.4 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d013"
  },
  {
    "code": "D014",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Methoxychlor at or above 10.0 mg/L (TCLP)",
    "contaminant": "Methoxychlor",
    "regulatoryLevel": "10.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d014"
  },
  {
    "code": "D015",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Toxaphene at or above 0.5 mg/L (TCLP)",
    "contaminant": "Toxaphene",
    "regulatoryLevel": "0.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d015"
  },
  {
    "code": "D016",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 2,4-D at or above 10.0 mg/L (TCLP)",
    "contaminant": "2,4-D",
    "regulatoryLevel": "10.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d016"
  },
  {
    "code": "D017",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 2,4,5-TP (Silvex) at or above 1.0 mg/L (TCLP)",
    "contaminant": "2,4,5-TP (Silvex)",
    "regulatoryLevel": "1.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d017"
  },
  {
    "code": "D018",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Benzene at or above 0.5 mg/L (TCLP)",
    "contaminant": "Benzene",
    "regulatoryLevel": "0.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d018"
  },
  {
    "code": "D019",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Carbon tetrachloride at or above 0.5 mg/L (TCLP)",
    "contaminant": "Carbon tetrachloride",
    "regulatoryLevel": "0.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d019"
  },
  {
    "code": "D020",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Chlordane at or above 0.03 mg/L (TCLP)",
    "contaminant": "Chlordane",
    "regulatoryLevel": "0.03 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d020"
  },
  {
    "code": "D021",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Chlorobenzene at or above 100.0 mg/L (TCLP)",
    "contaminant": "Chlorobenzene",
    "regulatoryLevel": "100.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d021"
  },
  {
    "code": "D022",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Chloroform at or above 6.0 mg/L (TCLP)",
    "contaminant": "Chloroform",
    "regulatoryLevel": "6.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d022"
  },
  {
    "code": "D023",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - o-Cresol at or above undefined mg/L (TCLP)",
    "contaminant": "o-Cresol",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d023"
  },
  {
    "code": "D024",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - m-Cresol at or above undefined mg/L (TCLP)",
    "contaminant": "m-Cresol",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d024"
  },
  {
    "code": "D025",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - p-Cresol at or above undefined mg/L (TCLP)",
    "contaminant": "p-Cresol",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d025"
  },
  {
    "code": "D026",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Cresol at or above undefined mg/L (TCLP)",
    "contaminant": "Cresol",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d026"
  },
  {
    "code": "D027",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 1,4-Dichlorobenzene at or above 7.5 mg/L (TCLP)",
    "contaminant": "1,4-Dichlorobenzene",
    "regulatoryLevel": "7.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d027"
  },
  {
    "code": "D028",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 1,2-Dichloroethane at or above 0.5 mg/L (TCLP)",
    "contaminant": "1,2-Dichloroethane",
    "regulatoryLevel": "0.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d028"
  },
  {
    "code": "D029",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 1,1-Dichloroethylene at or above 0.7 mg/L (TCLP)",
    "contaminant": "1,1-Dichloroethylene",
    "regulatoryLevel": "0.7 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d029"
  },
  {
    "code": "D030",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 2,4-Dinitrotoluene at or above undefined mg/L (TCLP)",
    "contaminant": "2,4-Dinitrotoluene",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d030"
  },
  {
    "code": "D031",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Heptachlor (and its epoxide) at or above 0.008 mg/L (TCLP)",
    "contaminant": "Heptachlor (and its epoxide)",
    "regulatoryLevel": "0.008 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d031"
  },
  {
    "code": "D032",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Hexachlorobenzene at or above undefined mg/L (TCLP)",
    "contaminant": "Hexachlorobenzene",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d032"
  },
  {
    "code": "D033",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Hexachlorobutadiene at or above 0.5 mg/L (TCLP)",
    "contaminant": "Hexachlorobutadiene",
    "regulatoryLevel": "0.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d033"
  },
  {
    "code": "D034",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Hexachloroethane at or above 3.0 mg/L (TCLP)",
    "contaminant": "Hexachloroethane",
    "regulatoryLevel": "3.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d034"
  },
  {
    "code": "D035",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Methyl ethyl ketone at or above 200.0 mg/L (TCLP)",
    "contaminant": "Methyl ethyl ketone",
    "regulatoryLevel": "200.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d035"
  },
  {
    "code": "D036",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Nitrobenzene at or above 2.0 mg/L (TCLP)",
    "contaminant": "Nitrobenzene",
    "regulatoryLevel": "2.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d036"
  },
  {
    "code": "D037",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Pentachlorophenol at or above 100.0 mg/L (TCLP)",
    "contaminant": "Pentachlorophenol",
    "regulatoryLevel": "100.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d037"
  },
  {
    "code": "D038",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Pyridine at or above undefined mg/L (TCLP)",
    "contaminant": "Pyridine",
    "regulatoryLevel": "undefined mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d038"
  },
  {
    "code": "D039",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Tetrachloroethylene at or above 0.7 mg/L (TCLP)",
    "contaminant": "Tetrachloroethylene",
    "regulatoryLevel": "0.7 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d039"
  },
  {
    "code": "D040",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Trichloroethylene at or above 0.5 mg/L (TCLP)",
    "contaminant": "Trichloroethylene",
    "regulatoryLevel": "0.5 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d040"
  },
  {
    "code": "D041",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 2,4,5-Trichlorophenol at or above 400.0 mg/L (TCLP)",
    "contaminant": "2,4,5-Trichlorophenol",
    "regulatoryLevel": "400.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d041"
  },
  {
    "code": "D042",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - 2,4,6-Trichlorophenol at or above 2.0 mg/L (TCLP)",
    "contaminant": "2,4,6-Trichlorophenol",
    "regulatoryLevel": "2.0 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d042"
  },
  {
    "code": "D043",
    "list": "D",
    "hazardBasis": "toxic-characteristic",
    "description": "Toxicity characteristic waste - Vinyl chloride at or above 0.2 mg/L (TCLP)",
    "contaminant": "Vinyl chloride",
    "regulatoryLevel": "0.2 mg/L",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-C/section-261.24",
    "codeSlug": "d043"
  },
  {
    "code": "F001",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "The following spent halogenated solvents used in degreasing: Tetrachloroethylene, trichloroethylene, methylene chloride, 1,1,1-trichloroethane, carbon tetrachloride, and chlorinated fluorocarbons; all spent solvent mixtures/blends used in degreasing containing, before use, a total of ten percent or more (by volume) of one or more of the above halogenated solvents or those solvents listed in F002, F004, and F005; and still bottoms from the recovery of these spent solvents and spent solvent mixtures",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f001"
  },
  {
    "code": "F002",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "The following spent halogenated solvents: Tetrachloroethylene, methylene chloride, trichloroethylene, 1,1,1-trichloroethane, chlorobenzene, 1,1,2-trichloro-1,2,2-trifluoroethane, ortho-dichlorobenzene, trichlorofluoromethane, and 1,1,2-trichloroethane; all spent solvent mixtures/blends containing, before use, a total of ten percent or more (by volume) of one or more of the above halogenated solvents or those listed in F001, F004, or F005; and still bottoms from the recovery of these spent solvents and spent solvent mixtures",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f002"
  },
  {
    "code": "F003",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "The following spent non-halogenated solvents: Xylene, acetone, ethyl acetate, ethyl benzene, ethyl ether, methyl isobutyl ketone, n-butyl alcohol, cyclohexanone, and methanol; all spent solvent mixtures/blends containing, before use, only the above spent non-halogenated solvents; and all spent solvent mixtures/blends containing, before use, one or more of the above non-halogenated solvents, and, a total of ten percent or more (by volume) of one or more of those solvents listed in F001, F002, F004, and F005; and still bottoms from the recovery of these spent solvents and spent solvent mixtures",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f003"
  },
  {
    "code": "F004",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "The following spent non-halogenated solvents: Cresols and cresylic acid, and nitrobenzene; all spent solvent mixtures/blends containing, before use, a total of ten percent or more (by volume) of one or more of the above non-halogenated solvents or those solvents listed in F001, F002, and F005; and still bottoms from the recovery of these spent solvents and spent solvent mixtures",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f004"
  },
  {
    "code": "F005",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "The following spent non-halogenated solvents: Toluene, methyl ethyl ketone, carbon disulfide, isobutanol, pyridine, benzene, 2-ethoxyethanol, and 2-nitropropane; all spent solvent mixtures/blends containing, before use, a total of ten percent or more (by volume) of one or more of the above non-halogenated solvents or those solvents listed in F001, F002, or F004; and still bottoms from the recovery of these spent solvents and spent solvent mixtures",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f005"
  },
  {
    "code": "F006",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from electroplating operations except from the following processes: (1) Sulfuric acid anodizing of aluminum; (2) tin plating on carbon steel; (3) zinc plating (segregated basis) on carbon steel; (4) aluminum or zinc-aluminum plating on carbon steel; (5) cleaning/stripping associated with tin, zinc and aluminum plating on carbon steel; and (6) chemical etching and milling of aluminum",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f006"
  },
  {
    "code": "F007",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Spent cyanide plating bath solutions from electroplating operations",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f007"
  },
  {
    "code": "F008",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Plating bath residues from the bottom of plating baths from electroplating operations where cyanides are used in the process",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f008"
  },
  {
    "code": "F009",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Spent stripping and cleaning bath solutions from electroplating operations where cyanides are used in the process",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f009"
  },
  {
    "code": "F010",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Quenching bath residues from oil baths from metal heat treating operations where cyanides are used in the process",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f010"
  },
  {
    "code": "F011",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Spent cyanide solutions from salt bath pot cleaning from metal heat treating operations",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f011"
  },
  {
    "code": "F012",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Quenching waste water treatment sludges from metal heat treating operations where cyanides are used in the process",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f012"
  },
  {
    "code": "F019",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from the chemical conversion coating of aluminum except from zirconium phosphating in aluminum can washing when such phosphating is an exclusive conversion coating process. Wastewater treatment sludges from the manufacturing of motor vehicles using a zinc phosphating process will not be subject to this listing at the point of generation if the wastes are not placed outside on the land prior to shipment to a landfill for disposal and are either: disposed in a Subtitle D municipal or industrial landfill unit that is equipped with a single clay liner and is permitted, licensed or otherwise authorized by the state; or disposed in a landfill unit subject to, or otherwise meeting, the landfill requirements in § 258.40, § 264.301 or § 265.301. For the purposes of this listing, motor vehicle manufacturing is defined in paragraph (b)(4)(i) of this section and (b)(4)(ii) of this section describes the recordkeeping requirements for motor vehicle manufacturing facilities",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f019"
  },
  {
    "code": "F020",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastes (except wastewater and spent carbon from hydrogen chloride purification) from the production or manufacturing use (as a reactant, chemical intermediate, or component in a formulating process) of tri- or tetrachlorophenol, or of intermediates used to produce their pesticide derivatives. (This listing does not include wastes from the production of Hexachlorophene from highly purified 2,4,5-trichlorophenol.)",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f020"
  },
  {
    "code": "F021",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastes (except wastewater and spent carbon from hydrogen chloride purification) from the production or manufacturing use (as a reactant, chemical intermediate, or component in a formulating process) of pentachlorophenol, or of intermediates used to produce its derivatives",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f021"
  },
  {
    "code": "F022",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastes (except wastewater and spent carbon from hydrogen chloride purification) from the manufacturing use (as a reactant, chemical intermediate, or component in a formulating process) of tetra-, penta-, or hexachlorobenzenes under alkaline conditions",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f022"
  },
  {
    "code": "F023",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastes (except wastewater and spent carbon from hydrogen chloride purification) from the production of materials on equipment previously used for the production or manufacturing use (as a reactant, chemical intermediate, or component in a formulating process) of tri- and tetrachlorophenols. (This listing does not include wastes from equipment used only for the production or use of Hexachlorophene from highly purified 2,4,5-trichlorophenol.)",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f023"
  },
  {
    "code": "F024",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Process wastes, including but not limited to, distillation residues, heavy ends, tars, and reactor clean-out wastes, from the production of certain chlorinated aliphatic hydrocarbons by free radical catalyzed processes. These chlorinated aliphatic hydrocarbons are those having carbon chain lengths ranging from one to and including five, with varying amounts and positions of chlorine substitution. (This listing does not include wastewaters, wastewater treatment sludges, spent catalysts, and wastes listed in § 261.31 or § 261.32.)",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f024"
  },
  {
    "code": "F025",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Condensed light ends, spent filters and filter aids, and spent desiccant wastes from the production of certain chlorinated aliphatic hydrocarbons, by free radical catalyzed processes. These chlorinated aliphatic hydrocarbons are those having carbon chain lengths ranging from one to and including five, with varying amounts and positions of chlorine substitution",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f025"
  },
  {
    "code": "F026",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastes (except wastewater and spent carbon from hydrogen chloride purification) from the production of materials on equipment previously used for the manufacturing use (as a reactant, chemical intermediate, or component in a formulating process) of tetra-, penta-, or hexachlorobenzene under alkaline conditions",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f026"
  },
  {
    "code": "F027",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Discarded unused formulations containing tri-, tetra-, or pentachlorophenol or discarded unused formulations containing compounds derived from these chlorophenols. (This listing does not include formulations containing Hexachlorophene sythesized from prepurified 2,4,5-trichlorophenol as the sole component.)",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f027"
  },
  {
    "code": "F028",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Residues resulting from the incineration or thermal treatment of soil contaminated with EPA Hazardous Waste Nos. F020, F021, F022, F023, F026, and F027",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f028"
  },
  {
    "code": "F032",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastewaters (except those that have not come into contact with process contaminants), process residuals, preservative drippage, and spent formulations from wood preserving processes generated at plants that currently use or have previously used chlorophenolic formulations (except potentially cross-contaminated wastes that have had the F032 waste code deleted in accordance with § 261.35 of this chapter or potentially cross-contaminated wastes that are otherwise currently regulated as hazardous wastes (i.e., F034 or F035), and where the generator does not resume or initiate use of chlorophenolic formulations). This listing does not include K001 bottom sediment sludge from the treatment of wastewater from wood preserving processes that use creosote and/or pentachlorophenol",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f032"
  },
  {
    "code": "F034",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastewaters (except those that have not come into contact with process contaminants), process residuals, preservative drippage, and spent formulations from wood preserving processes generated at plants that use creosote formulations. This listing does not include K001 bottom sediment sludge from the treatment of wastewater from wood preserving processes that use creosote and/or pentachlorophenol",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f034"
  },
  {
    "code": "F035",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Wastewaters (except those that have not come into contact with process contaminants), process residuals, preservative drippage, and spent formulations from wood preserving processes generated at plants that use inorganic preservatives containing arsenic or chromium. This listing does not include K001 bottom sediment sludge from the treatment of wastewater from wood preserving processes that use creosote and/or pentachlorophenol",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f035"
  },
  {
    "code": "F037",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Petroleum refinery primary oil/water/solids separation sludge—Any sludge generated from the gravitational separation of oil/water/solids during the storage or treatment of process wastewaters and oily cooling wastewaters from petroleum refineries. Such sludges include, but are not limited to, those generated in oil/water/solids separators; tanks and impoundments; ditches and other conveyances; sumps; and stormwater units receiving dry weather flow. Sludge generated in stormwater units that do not receive dry weather flow, sludges generated from non-contact once-through cooling waters segregated for treatment from other process or oily cooling waters, sludges generated in aggressive biological treatment units as defined in § 261.31(b)(2) (including sludges generated in one or more additional units after wastewaters have been treated in aggressive biological treatment units) and K051 wastes are not included in this listing. This listing does include residuals generated from processing or recycling oil-bearing hazardous secondary materials excluded under § 261.4(a)(12)(i), if those residuals are to be disposed of",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f037"
  },
  {
    "code": "F038",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Petroleum refinery secondary (emulsified) oil/water/solids separation sludge—Any sludge and/or float generated from the physical and/or chemical separation of oil/water/solids in process wastewaters and oily cooling wastewaters from petroleum refineries. Such wastes include, but are not limited to, all sludges and floats generated in: induced air flotation (IAF) units, tanks and impoundments, and all sludges generated in DAF units. Sludges generated in stormwater units that do not receive dry weather flow, sludges generated from non-contact once-through cooling waters segregated for treatment from other process or oily cooling waters, sludges and floats generated in aggressive biological treatment units as defined in § 261.31(b)(2) (including sludges and floats generated in one or more additional units after wastewaters have been treated in aggressive biological treatment units) and F037, K048, and K051 wastes are not included in this listing",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f038"
  },
  {
    "code": "F039",
    "list": "F",
    "hazardBasis": "listed-toxic",
    "description": "Leachate (liquids that have percolated through land disposed wastes) resulting from the disposal of more than one restricted waste classified as hazardous under subpart D of this part. (Leachate resulting from the disposal of one or more of the following EPA Hazardous Wastes and no other Hazardous Wastes retains its EPA Hazardous Waste Number(s): F020, F021, F022, F026, F027, and/or F028.)",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.31",
    "codeSlug": "f039"
  },
  {
    "code": "K001",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Bottom sediment sludge from the treatment of wastewaters from wood preserving processes that use creosote and/or pentachlorophenol",
    "industrySource": "Wood preservation",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k001"
  },
  {
    "code": "K002",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of chrome yellow and orange pigments",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k002"
  },
  {
    "code": "K003",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of molybdate orange pigments",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k003"
  },
  {
    "code": "K004",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of zinc yellow pigments",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k004"
  },
  {
    "code": "K005",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of chrome green pigments",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k005"
  },
  {
    "code": "K006",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of chrome oxide green pigments (anhydrous and hydrated)",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k006"
  },
  {
    "code": "K007",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of iron blue pigments",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k007"
  },
  {
    "code": "K008",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Oven residue from the production of chrome oxide green pigments",
    "industrySource": "Inorganic pigments",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k008"
  },
  {
    "code": "K009",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from the production of acetaldehyde from ethylene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k009"
  },
  {
    "code": "K010",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation side cuts from the production of acetaldehyde from ethylene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k010"
  },
  {
    "code": "K011",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Bottom stream from the wastewater stripper in the production of acrylonitrile",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k011"
  },
  {
    "code": "K013",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Bottom stream from the acetonitrile column in the production of acrylonitrile",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k013"
  },
  {
    "code": "K014",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Bottoms from the acetonitrile purification column in the production of acrylonitrile",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k014"
  },
  {
    "code": "K015",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Still bottoms from the distillation of benzyl chloride",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k015"
  },
  {
    "code": "K016",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends or distillation residues from the production of carbon tetrachloride",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k016"
  },
  {
    "code": "K017",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends (still bottoms) from the purification column in the production of epichlorohydrin",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k017"
  },
  {
    "code": "K018",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends from the fractionation column in ethyl chloride production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k018"
  },
  {
    "code": "K019",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends from the distillation of ethylene dichloride in ethylene dichloride production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k019"
  },
  {
    "code": "K020",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends from the distillation of vinyl chloride in vinyl chloride monomer production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k020"
  },
  {
    "code": "K021",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Aqueous spent antimony catalyst waste from fluoromethanes production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k021"
  },
  {
    "code": "K022",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottom tars from the production of phenol/acetone from cumene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k022"
  },
  {
    "code": "K023",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation light ends from the production of phthalic anhydride from naphthalene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k023"
  },
  {
    "code": "K024",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from the production of phthalic anhydride from naphthalene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k024"
  },
  {
    "code": "K025",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from the production of nitrobenzene by the nitration of benzene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k025"
  },
  {
    "code": "K026",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Stripping still tails from the production of methy ethyl pyridines",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k026"
  },
  {
    "code": "K027",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Centrifuge and distillation residues from toluene diisocyanate production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k027"
  },
  {
    "code": "K028",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent catalyst from the hydrochlorinator reactor in the production of 1,1,1-trichloroethane",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k028"
  },
  {
    "code": "K029",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Waste from the product steam stripper in the production of 1,1,1-trichloroethane",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k029"
  },
  {
    "code": "K030",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Column bottoms or heavy ends from the combined production of trichloroethylene and perchloroethylene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k030"
  },
  {
    "code": "K031",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "By-product salts generated in the production of MSMA and cacodylic acid",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k031"
  },
  {
    "code": "K032",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of chlordane",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k032"
  },
  {
    "code": "K033",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater and scrub water from the chlorination of cyclopentadiene in the production of chlordane",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k033"
  },
  {
    "code": "K034",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Filter solids from the filtration of hexachlorocyclopentadiene in the production of chlordane",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k034"
  },
  {
    "code": "K035",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges generated in the production of creosote",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k035"
  },
  {
    "code": "K036",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Still bottoms from toluene reclamation distillation in the production of disulfoton",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k036"
  },
  {
    "code": "K037",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from the production of disulfoton",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k037"
  },
  {
    "code": "K038",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater from the washing and stripping of phorate production",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k038"
  },
  {
    "code": "K039",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Filter cake from the filtration of diethylphosphorodithioic acid in the production of phorate",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k039"
  },
  {
    "code": "K040",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of phorate",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k040"
  },
  {
    "code": "K041",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the production of toxaphene",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k041"
  },
  {
    "code": "K042",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends or distillation residues from the distillation of tetrachlorobenzene in the production of 2,4,5-T",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k042"
  },
  {
    "code": "K043",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "2,6-Dichlorophenol waste from the production of 2,4-D",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k043"
  },
  {
    "code": "K044",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from the manufacturing and processing of explosives",
    "industrySource": "Explosives",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k044"
  },
  {
    "code": "K045",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent carbon from the treatment of wastewater containing explosives",
    "industrySource": "Explosives",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k045"
  },
  {
    "code": "K046",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from the manufacturing, formulation and loading of lead-based initiating compounds",
    "industrySource": "Explosives",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k046"
  },
  {
    "code": "K047",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Pink/red water from TNT operations",
    "industrySource": "Explosives",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k047"
  },
  {
    "code": "K048",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Dissolved air flotation (DAF) float from the petroleum refining industry",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k048"
  },
  {
    "code": "K049",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Slop oil emulsion solids from the petroleum refining industry",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k049"
  },
  {
    "code": "K050",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heat exchanger bundle cleaning sludge from the petroleum refining industry",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k050"
  },
  {
    "code": "K051",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "API separator sludge from the petroleum refining industry",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k051"
  },
  {
    "code": "K052",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Tank bottoms (leaded) from the petroleum refining industry",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k052"
  },
  {
    "code": "K060",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Ammonia still lime sludge from coking operations",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k060"
  },
  {
    "code": "K061",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Emission control dust/sludge from the primary production of steel in electric furnaces",
    "industrySource": "Iron and steel",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k061"
  },
  {
    "code": "K062",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent pickle liquor generated by steel finishing operations of facilities within the iron and steel industry (SIC Codes 331 and 332)",
    "industrySource": "Iron and steel",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k062"
  },
  {
    "code": "K069",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Emission control dust/sludge from secondary lead smelting. ( Note: This listing is stayed administratively for sludge generated from secondary acid scrubber systems. The stay will remain in effect until further administrative action is taken. If EPA takes further action effecting this stay, EPA will publish a notice of the action in the Federal Register )",
    "industrySource": "Secondary lead",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k069"
  },
  {
    "code": "K071",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Brine purification muds from the mercury cell process in chlorine production, where separately prepurified brine is not used",
    "industrySource": "Inorganic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k071"
  },
  {
    "code": "K073",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Chlorinated hydrocarbon waste from the purification step of the diaphragm cell process using graphite anodes in chlorine production",
    "industrySource": "Inorganic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k073"
  },
  {
    "code": "K083",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from aniline production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k083"
  },
  {
    "code": "K084",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges generated during the production of veterinary pharmaceuticals from arsenic or organo-arsenic compounds",
    "industrySource": "Veterinary pharmaceuticals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k084"
  },
  {
    "code": "K085",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation or fractionation column bottoms from the production of chlorobenzenes",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k085"
  },
  {
    "code": "K086",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Solvent washes and sludges, caustic washes and sludges, or water washes and sludges from cleaning tubs and equipment used in the formulation of ink from pigments, driers, soaps, and stabilizers containing chromium and lead",
    "industrySource": "Ink formulation",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k086"
  },
  {
    "code": "K087",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Decanter tank tar sludge from coking operations",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k087"
  },
  {
    "code": "K088",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent potliners from primary aluminum reduction",
    "industrySource": "Primary aluminum",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k088"
  },
  {
    "code": "K093",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation light ends from the production of phthalic anhydride from ortho-xylene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k093"
  },
  {
    "code": "K094",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from the production of phthalic anhydride from ortho-xylene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k094"
  },
  {
    "code": "K095",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from the production of 1,1,1-trichloroethane",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k095"
  },
  {
    "code": "K096",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends from the heavy ends column from the production of 1,1,1-trichloroethane",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k096"
  },
  {
    "code": "K097",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Vacuum stripper discharge from the chlordane chlorinator in the production of chlordane",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k097"
  },
  {
    "code": "K098",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Untreated process wastewater from the production of toxaphene",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k098"
  },
  {
    "code": "K099",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Untreated wastewater from the production of 2,4-D",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k099"
  },
  {
    "code": "K100",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Waste leaching solution from acid leaching of emission control dust/sludge from secondary lead smelting",
    "industrySource": "Secondary lead",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k100"
  },
  {
    "code": "K101",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation tar residues from the distillation of aniline-based compounds in the production of veterinary pharmaceuticals from arsenic or organo-arsenic compounds",
    "industrySource": "Veterinary pharmaceuticals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k101"
  },
  {
    "code": "K102",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Residue from the use of activated carbon for decolorization in the production of veterinary pharmaceuticals from arsenic or organo-arsenic compounds",
    "industrySource": "Veterinary pharmaceuticals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k102"
  },
  {
    "code": "K103",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Process residues from aniline extraction from the production of aniline",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k103"
  },
  {
    "code": "K104",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Combined wastewater streams generated from nitrobenzene/aniline production",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k104"
  },
  {
    "code": "K105",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Separated aqueous stream from the reactor product washing step in the production of chlorobenzenes",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k105"
  },
  {
    "code": "K106",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludge from the mercury cell process in chlorine production",
    "industrySource": "Inorganic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k106"
  },
  {
    "code": "K107",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Column bottoms from product separation from the production of 1,1-dimethylhydrazine (UDMH) from carboxylic acid hydrazides",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k107"
  },
  {
    "code": "K108",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Condensed column overheads from product separation and condensed reactor vent gases from the production of 1,1-dimethylhydrazine (UDMH) from carboxylic acid hydrazides",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k108"
  },
  {
    "code": "K109",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent filter cartridges from product purification from the production of 1,1-dimethylhydrazine (UDMH) from carboxylic acid hydrazides",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k109"
  },
  {
    "code": "K110",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Condensed column overheads from intermediate separation from the production of 1,1-dimethylhydrazine (UDMH) from carboxylic acid hydrazides",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k110"
  },
  {
    "code": "K111",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Product washwaters from the production of dinitrotoluene via nitration of toluene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k111"
  },
  {
    "code": "K112",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Reaction by-product water from the drying column in the production of toluenediamine via hydrogenation of dinitrotoluene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k112"
  },
  {
    "code": "K113",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Condensed liquid light ends from the purification of toluenediamine in the production of toluenediamine via hydrogenation of dinitrotoluene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k113"
  },
  {
    "code": "K114",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Vicinals from the purification of toluenediamine in the production of toluenediamine via hydrogenation of dinitrotoluene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k114"
  },
  {
    "code": "K115",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Heavy ends from the purification of toluenediamine in the production of toluenediamine via hydrogenation of dinitrotoluene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k115"
  },
  {
    "code": "K116",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Organic condensate from the solvent recovery column in the production of toluene diisocyanate via phosgenation of toluenediamine",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k116"
  },
  {
    "code": "K117",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater from the reactor vent gas scrubber in the production of ethylene dibromide via bromination of ethene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k117"
  },
  {
    "code": "K118",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent adsorbent solids from purification of ethylene dibromide in the production of ethylene dibromide via bromination of ethene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k118"
  },
  {
    "code": "K123",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Process wastewater (including supernates, filtrates, and washwaters) from the production of ethylenebisdithiocarbamic acid and its salt",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k123"
  },
  {
    "code": "K124",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Reactor vent scrubber water from the production of ethylenebisdithiocarbamic acid and its salts",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k124"
  },
  {
    "code": "K125",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Filtration, evaporation, and centrifugation solids from the production of ethylenebisdithiocarbamic acid and its salts",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k125"
  },
  {
    "code": "K126",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Baghouse dust and floor sweepings in milling and packaging operations from the production or formulation of ethylenebisdithiocarbamic acid and its salts",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k126"
  },
  {
    "code": "K131",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater from the reactor and spent sulfuric acid from the acid dryer from the production of methyl bromide",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k131"
  },
  {
    "code": "K132",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent absorbent and wastewater separator solids from the production of methyl bromide",
    "industrySource": "Pesticides",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k132"
  },
  {
    "code": "K136",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Still bottoms from the purification of ethylene dibromide in the production of ethylene dibromide via bromination of ethene",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k136"
  },
  {
    "code": "K141",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Process residues from the recovery of coal tar, including, but not limited to, collecting sump residues from the production of coke from coal or the recovery of coke by-products produced from coal. This listing does not include K087 (decanter tank tar sludges from coking operations)",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k141"
  },
  {
    "code": "K142",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Tar storage tank residues from the production of coke from coal or from the recovery of coke by-products produced from coal",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k142"
  },
  {
    "code": "K143",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Process residues from the recovery of light oil, including, but not limited to, those generated in stills, decanters, and wash oil recovery units from the recovery of coke by-products produced from coal",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k143"
  },
  {
    "code": "K144",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater sump residues from light oil refining, including, but not limited to, intercepting or contamination sump sludges from the recovery of coke by-products produced from coal",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k144"
  },
  {
    "code": "K145",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Residues from naphthalene collection and recovery operations from the recovery of coke by-products produced from coal",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k145"
  },
  {
    "code": "K147",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Tar storage tank residues from coal tar refining",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k147"
  },
  {
    "code": "K148",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Residues from coal tar distillation, including but not limited to, still bottoms",
    "industrySource": "Coking",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k148"
  },
  {
    "code": "K149",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Distillation bottoms from the production of alpha- (or methyl-) chlorinated toluenes, ring-chlorinated toluenes, benzoyl chlorides, and compounds with mixtures of these functional groups, (This waste does not include still bottoms from the distillation of benzyl chloride.)",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k149"
  },
  {
    "code": "K150",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Organic residuals, excluding spent carbon adsorbent, from the spent chlorine gas and hydrochloric acid recovery processes associated with the production of alpha- (or methyl-) chlorinated toluenes, ring-chlorinated toluenes, benzoyl chlorides, and compounds with mixtures of these functional groups",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k150"
  },
  {
    "code": "K151",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges, excluding neutralization and biological sludges, generated during the treatment of wastewaters from the production of alpha- (or methyl-) chlorinated toluenes, ring-chlorinated toluenes, benzoyl chlorides, and compounds with mixtures of these functional groups",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k151"
  },
  {
    "code": "K156",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Organic waste (including heavy ends, still bottoms, light ends, spent solvents, filtrates, and decantates) from the production of carbamates and carbamoyl oximes. (This listing does not apply to wastes generated from the manufacture of 3-iodo-2-propynyl n-butylcarbamate.)",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k156"
  },
  {
    "code": "K157",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewaters (including scrubber waters, condenser waters, washwaters, and separation waters) from the production of carbamates and carbamoyl oximes. (This listing does not apply to wastes generated from the manufacture of 3-iodo-2-propynyl n-butylcarbamate.)",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k157"
  },
  {
    "code": "K158",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Bag house dusts and filter/separation solids from the production of carbamates and carbamoyl oximes. (This listing does not apply to wastes generated from the manufacture of 3-iodo-2-propynyl n-butylcarbamate.)",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k158"
  },
  {
    "code": "K159",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Organics from the treatment of thiocarbamate wastes",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k159"
  },
  {
    "code": "K161",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Purification solids (including filtration, evaporation, and centrifugation solids), bag house dust and floor sweepings from the production of dithiocarbamate acids and their salts. (This listing does not include K125 or K126.)",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k161"
  },
  {
    "code": "K169",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Crude oil storage tank sediment from petroleum refining operations",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k169"
  },
  {
    "code": "K170",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Clarified slurry oil tank sediment and/or in-line filter/separation solids from petroleum refining operations",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k170"
  },
  {
    "code": "K171",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent Hydrotreating catalyst from petroleum refining operations, including guard beds used to desulfurize feeds to other catalytic reactors (this listing does not include inert support media)",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k171"
  },
  {
    "code": "K172",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Spent Hydrorefining catalyst from petroleum refining operations, including guard beds used to desulfurize feeds to other catalytic reactors (this listing does not include inert support media)",
    "industrySource": "Petroleum refining",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k172"
  },
  {
    "code": "K174",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from the production of ethylene dichloride or vinyl chloride monomer (including sludges that result from commingled ethylene dichloride or vinyl chloride monomer wastewater and other wastewater), unless the sludges meet the following conditions: (i) they are disposed of in a subtitle C or non-hazardous landfill licensed or permitted by the state or federal government; (ii) they are not otherwise placed on the land prior to final disposal; and (iii) the generator maintains documentation demonstrating that the waste was either disposed of in an on-site landfill or consigned to a transporter or disposal facility that provided a written commitment to dispose of the waste in an off-site landfill. Respondents in any action brought to enforce the requirements of subtitle C must, upon a showing by the government that the respondent managed wastewater treatment sludges from the production of vinyl chloride monomer or ethylene dichloride, demonstrate that they meet the terms of the exclusion set forth above. In doing so, they must provide appropriate documentation (e.g., contracts between the generator and the landfill owner/operator, invoices documenting delivery of waste to landfill, etc.) that the terms of the exclusion were met",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k174"
  },
  {
    "code": "K175",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Wastewater treatment sludges from the production of vinyl chloride monomer using mercuric chloride catalyst in an acetylene-based process",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k175"
  },
  {
    "code": "K176",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Baghouse filters from the production of antimony oxide, including filters from the production of intermediates (e.g., antimony metal or crude antimony oxide)",
    "industrySource": "Inorganic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k176"
  },
  {
    "code": "K177",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Slag from the production of antimony oxide that is speculatively accumulated or disposed, including slag from the production of intermediates (e.g., antimony metal or crude antimony oxide)",
    "industrySource": "Inorganic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k177"
  },
  {
    "code": "K178",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Residues from manufacturing and manufacturing-site storage of ferric chloride from acids formed during the production of titanium dioxide using the chloride-ilmenite process",
    "industrySource": "Inorganic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k178"
  },
  {
    "code": "K181",
    "list": "K",
    "hazardBasis": "listed-toxic",
    "description": "Nonwastewaters from the production of dyes and/or pigments (including nonwastewaters commingled at the point of generation with nonwastewaters from other processes) that, at the point of generation, contain mass loadings of any of the constituents identified in paragraph (c) of this section that are equal to or greater than the corresponding paragraph (c) levels, as determined on a calendar year basis. These wastes will not be hazardous if the nonwastewaters are: (i) disposed in a Subtitle D landfill unit subject to the design criteria in § 258.40, (ii) disposed in a Subtitle C landfill unit subject to either § 264.301 or § 265.301, (iii) disposed in other Subtitle D landfill units that meet the design criteria in § 258.40, § 264.301, or § 265.301, or (iv) treated in a combustion unit that is permitted under Subtitle C, or an onsite combustion unit that is permitted under the Clean Air Act. For the purposes of this listing, dyes and/or pigments production is defined in paragraph (b)(1) of this section. Paragraph (d) of this section describes the process for demonstrating that a facility's nonwastewaters are not K181. This listing does not apply to wastes that are otherwise identified as hazardous under §§ 261.21-261.24 and 261.31-261.33 at the point of generation. Also, the listing does not apply to wastes generated before any annual mass loading limit is met",
    "industrySource": "Organic chemicals",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.32",
    "codeSlug": "k181"
  },
  {
    "code": "P001",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "2H-1-Benzopyran-2-one, 4-hydroxy-3-(3-oxo-1-phenylbutyl)-, & salts, when present at concentrations greater than 0.3%",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p001"
  },
  {
    "code": "P002",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Acetamide, N-(aminothioxomethyl)-",
    "casNumber": "591-08-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p002"
  },
  {
    "code": "P003",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Acrolein",
    "casNumber": "107-02-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p003"
  },
  {
    "code": "P004",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Aldrin",
    "casNumber": "309-00-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p004"
  },
  {
    "code": "P005",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Allyl alcohol",
    "casNumber": "107-18-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p005"
  },
  {
    "code": "P006",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Aluminum phosphide",
    "casNumber": "20859-73-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p006"
  },
  {
    "code": "P007",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "5-(Aminomethyl)-3-isoxazolol",
    "casNumber": "2763-96-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p007"
  },
  {
    "code": "P008",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "4-Aminopyridine",
    "casNumber": "504-24-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p008"
  },
  {
    "code": "P009",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Ammonium picrate",
    "casNumber": "131-74-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p009"
  },
  {
    "code": "P010",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Arsenic acid H 3 AsO 4",
    "casNumber": "7778-39-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p010"
  },
  {
    "code": "P011",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Arsenic pentoxide",
    "casNumber": "1303-28-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p011"
  },
  {
    "code": "P012",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Arsenic trioxide",
    "casNumber": "1327-53-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p012"
  },
  {
    "code": "P013",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Barium cyanide",
    "casNumber": "542-62-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p013"
  },
  {
    "code": "P014",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Benzenethiol",
    "casNumber": "108-98-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p014"
  },
  {
    "code": "P015",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Beryllium powder",
    "casNumber": "7440-41-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p015"
  },
  {
    "code": "P016",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Dichloromethyl ether",
    "casNumber": "542-88-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p016"
  },
  {
    "code": "P017",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Bromoacetone",
    "casNumber": "598-31-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p017"
  },
  {
    "code": "P018",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Brucine",
    "casNumber": "357-57-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p018"
  },
  {
    "code": "P020",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Dinoseb",
    "casNumber": "88-85-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p020"
  },
  {
    "code": "P021",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Calcium cyanide",
    "casNumber": "592-01-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p021"
  },
  {
    "code": "P022",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Carbon disulfide",
    "casNumber": "75-15-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p022"
  },
  {
    "code": "P023",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Acetaldehyde, chloro-",
    "casNumber": "107-20-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p023"
  },
  {
    "code": "P024",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "p-Chloroaniline",
    "casNumber": "106-47-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p024"
  },
  {
    "code": "P026",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "1-(o-Chlorophenyl)thiourea",
    "casNumber": "5344-82-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p026"
  },
  {
    "code": "P027",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "3-Chloropropionitrile",
    "casNumber": "542-76-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p027"
  },
  {
    "code": "P028",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Benzene, (chloromethyl)-",
    "casNumber": "100-44-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p028"
  },
  {
    "code": "P029",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Copper cyanide",
    "casNumber": "544-92-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p029"
  },
  {
    "code": "P030",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Cyanides (soluble cyanide salts), not otherwise specified",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p030"
  },
  {
    "code": "P031",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Cyanogen",
    "casNumber": "460-19-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p031"
  },
  {
    "code": "P033",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Cyanogen chloride",
    "casNumber": "506-77-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p033"
  },
  {
    "code": "P034",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "2-Cyclohexyl-4,6-dinitrophenol",
    "casNumber": "131-89-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p034"
  },
  {
    "code": "P036",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Arsonous dichloride, phenyl-",
    "casNumber": "696-28-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p036"
  },
  {
    "code": "P037",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Dieldrin",
    "casNumber": "60-57-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p037"
  },
  {
    "code": "P038",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Arsine, diethyl-",
    "casNumber": "692-42-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p038"
  },
  {
    "code": "P039",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Disulfoton",
    "casNumber": "298-04-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p039"
  },
  {
    "code": "P040",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "O,O-Diethyl O-pyrazinyl phosphorothioate",
    "casNumber": "297-97-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p040"
  },
  {
    "code": "P041",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Diethyl-p-nitrophenyl phosphate",
    "casNumber": "311-45-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p041"
  },
  {
    "code": "P042",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Epinephrine",
    "casNumber": "51-43-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p042"
  },
  {
    "code": "P043",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Diisopropylfluorophosphate (DFP)",
    "casNumber": "55-91-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p043"
  },
  {
    "code": "P044",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Dimethoate",
    "casNumber": "60-51-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p044"
  },
  {
    "code": "P045",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Thiofanox",
    "casNumber": "39196-18-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p045"
  },
  {
    "code": "P046",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Benzeneethanamine, alpha,alpha-dimethyl-",
    "casNumber": "122-09-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p046"
  },
  {
    "code": "P047",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "4,6-Dinitro-o-cresol, & salts",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p047"
  },
  {
    "code": "P048",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "2,4-Dinitrophenol",
    "casNumber": "51-28-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p048"
  },
  {
    "code": "P049",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Dithiobiuret",
    "casNumber": "541-53-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p049"
  },
  {
    "code": "P050",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Endosulfan",
    "casNumber": "115-29-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p050"
  },
  {
    "code": "P051",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Endrin",
    "casNumber": "72-20-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p051"
  },
  {
    "code": "P054",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Aziridine",
    "casNumber": "151-56-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p054"
  },
  {
    "code": "P056",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Fluorine",
    "casNumber": "7782-41-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p056"
  },
  {
    "code": "P057",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Fluoroacetamide",
    "casNumber": "640-19-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p057"
  },
  {
    "code": "P058",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Acetic acid, fluoro-, sodium salt",
    "casNumber": "62-74-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p058"
  },
  {
    "code": "P059",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Heptachlor",
    "casNumber": "76-44-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p059"
  },
  {
    "code": "P060",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Isodrin",
    "casNumber": "465-73-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p060"
  },
  {
    "code": "P062",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Hexaethyl tetraphosphate",
    "casNumber": "757-58-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p062"
  },
  {
    "code": "P063",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Hydrocyanic acid",
    "casNumber": "74-90-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p063"
  },
  {
    "code": "P064",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Methane, isocyanato-",
    "casNumber": "624-83-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p064"
  },
  {
    "code": "P065",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Mercury fulminate",
    "casNumber": "628-86-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p065"
  },
  {
    "code": "P066",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Ethanimidothioic acid, N-[[(methylamino)carbonyl]oxy]-, methyl ester",
    "casNumber": "16752-77-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p066"
  },
  {
    "code": "P067",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Aziridine, 2-methyl-",
    "casNumber": "75-55-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p067"
  },
  {
    "code": "P068",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Hydrazine, methyl-",
    "casNumber": "60-34-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p068"
  },
  {
    "code": "P069",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "2-Methyllactonitrile",
    "casNumber": "75-86-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p069"
  },
  {
    "code": "P070",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Aldicarb",
    "casNumber": "116-06-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p070"
  },
  {
    "code": "P071",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Methyl parathion",
    "casNumber": "298-00-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p071"
  },
  {
    "code": "P072",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "alpha-Naphthylthiourea",
    "casNumber": "86-88-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p072"
  },
  {
    "code": "P073",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Nickel carbonyl",
    "casNumber": "13463-39-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p073"
  },
  {
    "code": "P074",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Nickel cyanide",
    "casNumber": "557-19-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p074"
  },
  {
    "code": "P075",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Nicotine, & salts (this listing does not include patches, gums and lozenges that are FDA-approved over-the-counter nicotine replacement therapies).",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p075"
  },
  {
    "code": "P076",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Nitric oxide",
    "casNumber": "10102-43-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p076"
  },
  {
    "code": "P077",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "p-Nitroaniline",
    "casNumber": "100-01-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p077"
  },
  {
    "code": "P078",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Nitrogen dioxide",
    "casNumber": "10102-44-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p078"
  },
  {
    "code": "P081",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Nitroglycerine",
    "casNumber": "55-63-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p081"
  },
  {
    "code": "P082",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Methanamine, N-methyl-N-nitroso-",
    "casNumber": "62-75-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p082"
  },
  {
    "code": "P084",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "N-Nitrosomethylvinylamine",
    "casNumber": "4549-40-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p084"
  },
  {
    "code": "P085",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Diphosphoramide, octamethyl-",
    "casNumber": "152-16-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p085"
  },
  {
    "code": "P087",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Osmium tetroxide",
    "casNumber": "20816-12-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p087"
  },
  {
    "code": "P088",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Endothall",
    "casNumber": "145-73-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p088"
  },
  {
    "code": "P089",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Parathion",
    "casNumber": "56-38-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p089"
  },
  {
    "code": "P092",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Mercury, (acetato-O)phenyl-",
    "casNumber": "62-38-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p092"
  },
  {
    "code": "P093",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Phenylthiourea",
    "casNumber": "103-85-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p093"
  },
  {
    "code": "P094",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Phorate",
    "casNumber": "298-02-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p094"
  },
  {
    "code": "P095",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Carbonic dichloride",
    "casNumber": "75-44-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p095"
  },
  {
    "code": "P096",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Hydrogen phosphide",
    "casNumber": "7803-51-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p096"
  },
  {
    "code": "P097",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Famphur",
    "casNumber": "52-85-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p097"
  },
  {
    "code": "P098",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Potassium cyanide",
    "casNumber": "151-50-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p098"
  },
  {
    "code": "P099",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Potassium silver cyanide",
    "casNumber": "506-61-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p099"
  },
  {
    "code": "P101",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Ethyl cyanide",
    "casNumber": "107-12-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p101"
  },
  {
    "code": "P102",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Propargyl alcohol",
    "casNumber": "107-19-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p102"
  },
  {
    "code": "P103",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Selenourea",
    "casNumber": "630-10-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p103"
  },
  {
    "code": "P104",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Silver cyanide",
    "casNumber": "506-64-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p104"
  },
  {
    "code": "P105",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Sodium azide",
    "casNumber": "26628-22-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p105"
  },
  {
    "code": "P106",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Sodium cyanide",
    "casNumber": "143-33-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p106"
  },
  {
    "code": "P108",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Strychnine, & salts",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p108"
  },
  {
    "code": "P109",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Tetraethyldithiopyrophosphate",
    "casNumber": "3689-24-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p109"
  },
  {
    "code": "P110",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Plumbane, tetraethyl-",
    "casNumber": "78-00-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p110"
  },
  {
    "code": "P111",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Diphosphoric acid, tetraethyl ester",
    "casNumber": "107-49-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p111"
  },
  {
    "code": "P112",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Methane, tetranitro-",
    "casNumber": "509-14-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p112"
  },
  {
    "code": "P113",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Thallic oxide",
    "casNumber": "1314-32-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p113"
  },
  {
    "code": "P114",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Thallium(I) selenite",
    "casNumber": "12039-52-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p114"
  },
  {
    "code": "P115",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Thallium(I) sulfate",
    "casNumber": "7446-18-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p115"
  },
  {
    "code": "P116",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Hydrazinecarbothioamide",
    "casNumber": "79-19-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p116"
  },
  {
    "code": "P118",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Methanethiol, trichloro-",
    "casNumber": "75-70-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p118"
  },
  {
    "code": "P119",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Ammonium vanadate",
    "casNumber": "7803-55-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p119"
  },
  {
    "code": "P120",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Vanadium pentoxide",
    "casNumber": "1314-62-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p120"
  },
  {
    "code": "P121",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Zinc cyanide",
    "casNumber": "557-21-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p121"
  },
  {
    "code": "P122",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Zinc phosphide Zn 3 P 2 , when present at concentrations greater than 10%",
    "casNumber": "1314-84-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p122"
  },
  {
    "code": "P123",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Toxaphene",
    "casNumber": "8001-35-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p123"
  },
  {
    "code": "P127",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Carbofuran.",
    "casNumber": "1563-66-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p127"
  },
  {
    "code": "P128",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Mexacarbate.",
    "casNumber": "315-18-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p128"
  },
  {
    "code": "P185",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Tirpate.",
    "casNumber": "26419-73-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p185"
  },
  {
    "code": "P188",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Physostigmine salicylate.",
    "casNumber": "57-64-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p188"
  },
  {
    "code": "P189",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Carbosulfan.",
    "casNumber": "55285-14-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p189"
  },
  {
    "code": "P190",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Metolcarb.",
    "casNumber": "1129-41-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p190"
  },
  {
    "code": "P191",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Dimetilan.",
    "casNumber": "644-64-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p191"
  },
  {
    "code": "P192",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Isolan.",
    "casNumber": "119-38-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p192"
  },
  {
    "code": "P194",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Oxamyl.",
    "casNumber": "23135-22-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p194"
  },
  {
    "code": "P196",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Manganese, bis(dimethylcarbamodithioato-S,S′)-,",
    "casNumber": "15339-36-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p196"
  },
  {
    "code": "P197",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Formparanate.",
    "casNumber": "17702-57-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p197"
  },
  {
    "code": "P198",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Formetanate hydrochloride.",
    "casNumber": "23422-53-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p198"
  },
  {
    "code": "P199",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Methiocarb.",
    "casNumber": "2032-65-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p199"
  },
  {
    "code": "P201",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Promecarb",
    "casNumber": "2631-37-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p201"
  },
  {
    "code": "P202",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "m-Cumenyl methylcarbamate.",
    "casNumber": "64-00-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p202"
  },
  {
    "code": "P203",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Aldicarb sulfone.",
    "casNumber": "1646-88-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p203"
  },
  {
    "code": "P204",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Physostigmine.",
    "casNumber": "57-47-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p204"
  },
  {
    "code": "P205",
    "list": "P",
    "hazardBasis": "listed-acute",
    "description": "Zinc, bis(dimethylcarbamodithioato-S,S′)-,",
    "casNumber": "137-30-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "p205"
  },
  {
    "code": "U001",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetaldehyde",
    "casNumber": "75-07-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u001"
  },
  {
    "code": "U002",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetone",
    "casNumber": "67-64-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u002"
  },
  {
    "code": "U003",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetonitrile",
    "casNumber": "75-05-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u003"
  },
  {
    "code": "U004",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetophenone",
    "casNumber": "98-86-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u004"
  },
  {
    "code": "U005",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetamide, N-9H-fluoren-2-yl-",
    "casNumber": "53-96-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u005"
  },
  {
    "code": "U006",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetyl chloride",
    "casNumber": "75-36-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u006"
  },
  {
    "code": "U007",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acrylamide",
    "casNumber": "79-06-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u007"
  },
  {
    "code": "U008",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acrylic acid",
    "casNumber": "79-10-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u008"
  },
  {
    "code": "U009",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acrylonitrile",
    "casNumber": "107-13-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u009"
  },
  {
    "code": "U010",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Mitomycin C",
    "casNumber": "50-07-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u010"
  },
  {
    "code": "U011",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Amitrole",
    "casNumber": "61-82-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u011"
  },
  {
    "code": "U012",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Aniline",
    "casNumber": "62-53-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u012"
  },
  {
    "code": "U014",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Auramine",
    "casNumber": "492-80-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u014"
  },
  {
    "code": "U015",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Azaserine",
    "casNumber": "115-02-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u015"
  },
  {
    "code": "U016",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benz[c]acridine",
    "casNumber": "225-51-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u016"
  },
  {
    "code": "U017",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzal chloride",
    "casNumber": "98-87-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u017"
  },
  {
    "code": "U018",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benz[a]anthracene",
    "casNumber": "56-55-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u018"
  },
  {
    "code": "U019",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene",
    "casNumber": "71-43-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u019"
  },
  {
    "code": "U020",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzenesulfonic acid chloride",
    "casNumber": "98-09-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u020"
  },
  {
    "code": "U021",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzidine",
    "casNumber": "92-87-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u021"
  },
  {
    "code": "U022",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzo[a]pyrene",
    "casNumber": "50-32-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u022"
  },
  {
    "code": "U023",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, (trichloromethyl)-",
    "casNumber": "98-07-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u023"
  },
  {
    "code": "U024",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dichloromethoxy ethane",
    "casNumber": "111-91-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u024"
  },
  {
    "code": "U025",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dichloroethyl ether",
    "casNumber": "111-44-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u025"
  },
  {
    "code": "U026",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chlornaphazin",
    "casNumber": "494-03-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u026"
  },
  {
    "code": "U027",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dichloroisopropyl ether",
    "casNumber": "108-60-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u027"
  },
  {
    "code": "U028",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Diethylhexyl phthalate",
    "casNumber": "117-81-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u028"
  },
  {
    "code": "U029",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methane, bromo-",
    "casNumber": "74-83-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u029"
  },
  {
    "code": "U030",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, 1-bromo-4-phenoxy-",
    "casNumber": "101-55-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u030"
  },
  {
    "code": "U031",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "n-Butyl alcohol",
    "casNumber": "71-36-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u031"
  },
  {
    "code": "U032",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Calcium chromate",
    "casNumber": "13765-19-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u032"
  },
  {
    "code": "U033",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbonic difluoride",
    "casNumber": "353-50-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u033"
  },
  {
    "code": "U034",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetaldehyde, trichloro-",
    "casNumber": "75-87-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u034"
  },
  {
    "code": "U035",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chlorambucil",
    "casNumber": "305-03-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u035"
  },
  {
    "code": "U036",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chlordane, alpha & gamma isomers",
    "casNumber": "57-74-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u036"
  },
  {
    "code": "U037",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, chloro-",
    "casNumber": "108-90-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u037"
  },
  {
    "code": "U038",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chlorobenzilate",
    "casNumber": "510-15-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u038"
  },
  {
    "code": "U039",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "p-Chloro-m-cresol",
    "casNumber": "59-50-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u039"
  },
  {
    "code": "U041",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Epichlorohydrin",
    "casNumber": "106-89-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u041"
  },
  {
    "code": "U042",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2-Chloroethyl vinyl ether",
    "casNumber": "110-75-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u042"
  },
  {
    "code": "U043",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethene, chloro-",
    "casNumber": "75-01-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u043"
  },
  {
    "code": "U044",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chloroform",
    "casNumber": "67-66-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u044"
  },
  {
    "code": "U045",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methane, chloro-",
    "casNumber": "74-87-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u045"
  },
  {
    "code": "U046",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chloromethyl methyl ether",
    "casNumber": "107-30-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u046"
  },
  {
    "code": "U047",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "beta-Chloronaphthalene",
    "casNumber": "91-58-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u047"
  },
  {
    "code": "U048",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "o-Chlorophenol",
    "casNumber": "95-57-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u048"
  },
  {
    "code": "U049",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzenamine, 4-chloro-2-methyl-, hydrochloride",
    "casNumber": "3165-93-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u049"
  },
  {
    "code": "U050",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Chrysene",
    "casNumber": "218-01-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u050"
  },
  {
    "code": "U051",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Creosote",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u051"
  },
  {
    "code": "U052",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Cresol (Cresylic acid)",
    "casNumber": "1319-77-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u052"
  },
  {
    "code": "U053",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Crotonaldehyde",
    "casNumber": "4170-30-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u053"
  },
  {
    "code": "U055",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Cumene",
    "casNumber": "98-82-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u055"
  },
  {
    "code": "U056",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, hexahydro-",
    "casNumber": "110-82-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u056"
  },
  {
    "code": "U057",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Cyclohexanone",
    "casNumber": "108-94-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u057"
  },
  {
    "code": "U058",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Cyclophosphamide",
    "casNumber": "50-18-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u058"
  },
  {
    "code": "U059",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Daunomycin",
    "casNumber": "20830-81-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u059"
  },
  {
    "code": "U060",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "DDD (Benzene, 1,1′-(2,2-dichloroethylidene)bis[4-chloro-)",
    "casNumber": "72-54-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u060"
  },
  {
    "code": "U061",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "DDT (Benzene, 1,1′-(2,2,2-trichloroethylidene)bis[4-chloro-)",
    "casNumber": "50-29-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u061"
  },
  {
    "code": "U062",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Diallate",
    "casNumber": "2303-16-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u062"
  },
  {
    "code": "U063",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dibenz[a,h]anthracene",
    "casNumber": "53-70-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u063"
  },
  {
    "code": "U064",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzo[rst]pentaphene",
    "casNumber": "189-55-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u064"
  },
  {
    "code": "U066",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,2-Dibromo-3-chloropropane",
    "casNumber": "96-12-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u066"
  },
  {
    "code": "U067",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylene dibromide",
    "casNumber": "106-93-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u067"
  },
  {
    "code": "U068",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methane, dibromo-",
    "casNumber": "74-95-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u068"
  },
  {
    "code": "U069",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dibutyl phthalate",
    "casNumber": "84-74-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u069"
  },
  {
    "code": "U070",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "o-Dichlorobenzene",
    "casNumber": "95-50-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u070"
  },
  {
    "code": "U071",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "m-Dichlorobenzene",
    "casNumber": "541-73-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u071"
  },
  {
    "code": "U072",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "p-Dichlorobenzene",
    "casNumber": "106-46-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u072"
  },
  {
    "code": "U073",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "[1,1′-Biphenyl]-4,4′-diamine, 3,3′-dichloro-",
    "casNumber": "91-94-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u073"
  },
  {
    "code": "U074",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2-Butene, 1,4-dichloro-",
    "casNumber": "764-41-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u074"
  },
  {
    "code": "U075",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dichlorodifluoromethane",
    "casNumber": "75-71-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u075"
  },
  {
    "code": "U076",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylidene dichloride",
    "casNumber": "75-34-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u076"
  },
  {
    "code": "U077",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylene dichloride",
    "casNumber": "107-06-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u077"
  },
  {
    "code": "U078",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,1-Dichloroethylene",
    "casNumber": "75-35-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u078"
  },
  {
    "code": "U079",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,2-Dichloroethylene",
    "casNumber": "156-60-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u079"
  },
  {
    "code": "U080",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methane, dichloro-",
    "casNumber": "75-09-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u080"
  },
  {
    "code": "U081",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2,4-Dichlorophenol",
    "casNumber": "120-83-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u081"
  },
  {
    "code": "U082",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2,6-Dichlorophenol",
    "casNumber": "87-65-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u082"
  },
  {
    "code": "U083",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Propylene dichloride",
    "casNumber": "78-87-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u083"
  },
  {
    "code": "U084",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,3-Dichloropropene",
    "casNumber": "542-75-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u084"
  },
  {
    "code": "U085",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2,2′-Bioxirane",
    "casNumber": "1464-53-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u085"
  },
  {
    "code": "U086",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N,N′-Diethylhydrazine",
    "casNumber": "1615-80-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u086"
  },
  {
    "code": "U087",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "O,O-Diethyl S-methyl dithiophosphate",
    "casNumber": "3288-58-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u087"
  },
  {
    "code": "U088",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Diethyl phthalate",
    "casNumber": "84-66-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u088"
  },
  {
    "code": "U089",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Diethylstilbesterol",
    "casNumber": "56-53-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u089"
  },
  {
    "code": "U090",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dihydrosafrole",
    "casNumber": "94-58-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u090"
  },
  {
    "code": "U091",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "[1,1′-Biphenyl]-4,4′-diamine, 3,3′-dimethoxy-",
    "casNumber": "119-90-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u091"
  },
  {
    "code": "U092",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dimethylamine",
    "casNumber": "124-40-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u092"
  },
  {
    "code": "U093",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "p-Dimethylaminoazobenzene",
    "casNumber": "60-11-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u093"
  },
  {
    "code": "U094",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benz[a]anthracene, 7,12-dimethyl-",
    "casNumber": "57-97-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u094"
  },
  {
    "code": "U095",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "[1,1′-Biphenyl]-4,4′-diamine, 3,3′-dimethyl-",
    "casNumber": "119-93-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u095"
  },
  {
    "code": "U096",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "alpha,alpha-Dimethylbenzylhydroperoxide",
    "casNumber": "80-15-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u096"
  },
  {
    "code": "U097",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbamic chloride, dimethyl-",
    "casNumber": "79-44-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u097"
  },
  {
    "code": "U098",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,1-Dimethylhydrazine",
    "casNumber": "57-14-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u098"
  },
  {
    "code": "U099",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,2-Dimethylhydrazine",
    "casNumber": "540-73-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u099"
  },
  {
    "code": "U101",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2,4-Dimethylphenol",
    "casNumber": "105-67-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u101"
  },
  {
    "code": "U102",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dimethyl phthalate",
    "casNumber": "131-11-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u102"
  },
  {
    "code": "U103",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dimethyl sulfate",
    "casNumber": "77-78-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u103"
  },
  {
    "code": "U105",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, 1-methyl-2,4-dinitro-",
    "casNumber": "121-14-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u105"
  },
  {
    "code": "U106",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, 2-methyl-1,3-dinitro-",
    "casNumber": "606-20-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u106"
  },
  {
    "code": "U107",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Di-n-octyl phthalate",
    "casNumber": "117-84-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u107"
  },
  {
    "code": "U108",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,4-Diethyleneoxide",
    "casNumber": "123-91-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u108"
  },
  {
    "code": "U109",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,2-Diphenylhydrazine",
    "casNumber": "122-66-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u109"
  },
  {
    "code": "U110",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Dipropylamine",
    "casNumber": "142-84-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u110"
  },
  {
    "code": "U111",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Di-n-propylnitrosamine",
    "casNumber": "621-64-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u111"
  },
  {
    "code": "U112",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetic acid ethyl ester",
    "casNumber": "141-78-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u112"
  },
  {
    "code": "U113",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethyl acrylate",
    "casNumber": "140-88-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u113"
  },
  {
    "code": "U114",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylenebisdithiocarbamic acid, salts & esters",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u114"
  },
  {
    "code": "U115",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylene oxide",
    "casNumber": "75-21-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u115"
  },
  {
    "code": "U116",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylenethiourea",
    "casNumber": "96-45-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u116"
  },
  {
    "code": "U117",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethyl ether",
    "casNumber": "60-29-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u117"
  },
  {
    "code": "U118",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethyl methacrylate",
    "casNumber": "97-63-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u118"
  },
  {
    "code": "U119",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethyl methanesulfonate",
    "casNumber": "62-50-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u119"
  },
  {
    "code": "U120",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Fluoranthene",
    "casNumber": "206-44-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u120"
  },
  {
    "code": "U121",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methane, trichlorofluoro-",
    "casNumber": "75-69-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u121"
  },
  {
    "code": "U122",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Formaldehyde",
    "casNumber": "50-00-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u122"
  },
  {
    "code": "U123",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Formic acid",
    "casNumber": "64-18-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u123"
  },
  {
    "code": "U124",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Furan",
    "casNumber": "110-00-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u124"
  },
  {
    "code": "U125",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Furfural",
    "casNumber": "98-01-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u125"
  },
  {
    "code": "U126",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Glycidylaldehyde",
    "casNumber": "765-34-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u126"
  },
  {
    "code": "U127",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, hexachloro-",
    "casNumber": "118-74-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u127"
  },
  {
    "code": "U128",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hexachlorobutadiene",
    "casNumber": "87-68-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u128"
  },
  {
    "code": "U129",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Lindane",
    "casNumber": "58-89-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u129"
  },
  {
    "code": "U130",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hexachlorocyclopentadiene",
    "casNumber": "77-47-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u130"
  },
  {
    "code": "U131",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethane, hexachloro-",
    "casNumber": "67-72-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u131"
  },
  {
    "code": "U132",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hexachlorophene",
    "casNumber": "70-30-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u132"
  },
  {
    "code": "U133",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hydrazine",
    "casNumber": "302-01-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u133"
  },
  {
    "code": "U134",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hydrofluoric acid",
    "casNumber": "7664-39-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u134"
  },
  {
    "code": "U135",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hydrogen sulfide",
    "casNumber": "7783-06-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u135"
  },
  {
    "code": "U136",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Arsinic acid, dimethyl-",
    "casNumber": "75-60-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u136"
  },
  {
    "code": "U137",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Indeno[1,2,3-cd]pyrene",
    "casNumber": "193-39-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u137"
  },
  {
    "code": "U138",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methane, iodo-",
    "casNumber": "74-88-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u138"
  },
  {
    "code": "U140",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Isobutyl alcohol",
    "casNumber": "78-83-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u140"
  },
  {
    "code": "U141",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Isosafrole",
    "casNumber": "120-58-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u141"
  },
  {
    "code": "U142",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Kepone",
    "casNumber": "143-50-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u142"
  },
  {
    "code": "U143",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Lasiocarpine",
    "casNumber": "303-34-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u143"
  },
  {
    "code": "U144",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Lead acetate",
    "casNumber": "301-04-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u144"
  },
  {
    "code": "U145",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Lead phosphate",
    "casNumber": "7446-27-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u145"
  },
  {
    "code": "U146",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Lead, bis(acetato-O)tetrahydroxytri-",
    "casNumber": "1335-32-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u146"
  },
  {
    "code": "U147",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Maleic anhydride",
    "casNumber": "108-31-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u147"
  },
  {
    "code": "U148",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Maleic hydrazide",
    "casNumber": "123-33-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u148"
  },
  {
    "code": "U149",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Malononitrile",
    "casNumber": "109-77-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u149"
  },
  {
    "code": "U150",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Melphalan",
    "casNumber": "148-82-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u150"
  },
  {
    "code": "U151",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Mercury",
    "casNumber": "7439-97-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u151"
  },
  {
    "code": "U152",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methacrylonitrile",
    "casNumber": "126-98-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u152"
  },
  {
    "code": "U153",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methanethiol",
    "casNumber": "74-93-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u153"
  },
  {
    "code": "U154",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methanol",
    "casNumber": "67-56-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u154"
  },
  {
    "code": "U155",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methapyrilene",
    "casNumber": "91-80-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u155"
  },
  {
    "code": "U156",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbonochloridic acid, methyl ester",
    "casNumber": "79-22-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u156"
  },
  {
    "code": "U157",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benz[j]aceanthrylene, 1,2-dihydro-3-methyl-",
    "casNumber": "56-49-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u157"
  },
  {
    "code": "U158",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzenamine, 4,4′-methylenebis[2-chloro-",
    "casNumber": "101-14-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u158"
  },
  {
    "code": "U159",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methyl ethyl ketone (MEK)",
    "casNumber": "78-93-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u159"
  },
  {
    "code": "U160",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methyl ethyl ketone peroxide",
    "casNumber": "1338-23-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u160"
  },
  {
    "code": "U161",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methyl isobutyl ketone",
    "casNumber": "108-10-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u161"
  },
  {
    "code": "U162",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methyl methacrylate",
    "casNumber": "80-62-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u162"
  },
  {
    "code": "U163",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Guanidine, N-methyl-N′-nitro-N-nitroso-",
    "casNumber": "70-25-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u163"
  },
  {
    "code": "U164",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methylthiouracil",
    "casNumber": "56-04-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u164"
  },
  {
    "code": "U165",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Naphthalene",
    "casNumber": "91-20-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u165"
  },
  {
    "code": "U166",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,4-Naphthalenedione",
    "casNumber": "130-15-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u166"
  },
  {
    "code": "U167",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "alpha-Naphthylamine",
    "casNumber": "134-32-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u167"
  },
  {
    "code": "U168",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "beta-Naphthylamine",
    "casNumber": "91-59-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u168"
  },
  {
    "code": "U169",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, nitro-",
    "casNumber": "98-95-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u169"
  },
  {
    "code": "U170",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "p-Nitrophenol",
    "casNumber": "100-02-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u170"
  },
  {
    "code": "U171",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2-Nitropropane",
    "casNumber": "79-46-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u171"
  },
  {
    "code": "U172",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N-Nitrosodi-n-butylamine",
    "casNumber": "924-16-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u172"
  },
  {
    "code": "U173",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N-Nitrosodiethanolamine",
    "casNumber": "1116-54-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u173"
  },
  {
    "code": "U174",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethanamine, N-ethyl-N-nitroso-",
    "casNumber": "55-18-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u174"
  },
  {
    "code": "U176",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N-Nitroso-N-ethylurea",
    "casNumber": "759-73-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u176"
  },
  {
    "code": "U177",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N-Nitroso-N-methylurea",
    "casNumber": "684-93-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u177"
  },
  {
    "code": "U178",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbamic acid, methylnitroso-, ethyl ester",
    "casNumber": "615-53-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u178"
  },
  {
    "code": "U179",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N-Nitrosopiperidine",
    "casNumber": "100-75-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u179"
  },
  {
    "code": "U180",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "N-Nitrosopyrrolidine",
    "casNumber": "930-55-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u180"
  },
  {
    "code": "U181",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzenamine, 2-methyl-5-nitro-",
    "casNumber": "99-55-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u181"
  },
  {
    "code": "U182",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Paraldehyde",
    "casNumber": "123-63-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u182"
  },
  {
    "code": "U183",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, pentachloro-",
    "casNumber": "608-93-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u183"
  },
  {
    "code": "U184",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethane, pentachloro-",
    "casNumber": "76-01-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u184"
  },
  {
    "code": "U185",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, pentachloronitro-",
    "casNumber": "82-68-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u185"
  },
  {
    "code": "U186",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1-Methylbutadiene",
    "casNumber": "504-60-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u186"
  },
  {
    "code": "U187",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Phenacetin",
    "casNumber": "62-44-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u187"
  },
  {
    "code": "U188",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Phenol",
    "casNumber": "108-95-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u188"
  },
  {
    "code": "U189",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Phosphorus sulfide",
    "casNumber": "1314-80-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u189"
  },
  {
    "code": "U190",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Phthalic anhydride",
    "casNumber": "85-44-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u190"
  },
  {
    "code": "U191",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2-Picoline",
    "casNumber": "109-06-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u191"
  },
  {
    "code": "U192",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Pronamide",
    "casNumber": "23950-58-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u192"
  },
  {
    "code": "U193",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1,2-Oxathiolane, 2,2-dioxide",
    "casNumber": "1120-71-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u193"
  },
  {
    "code": "U194",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "n-Propylamine",
    "casNumber": "107-10-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u194"
  },
  {
    "code": "U196",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Pyridine",
    "casNumber": "110-86-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u196"
  },
  {
    "code": "U197",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "p-Benzoquinone",
    "casNumber": "106-51-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u197"
  },
  {
    "code": "U200",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Reserpine",
    "casNumber": "50-55-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u200"
  },
  {
    "code": "U201",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Resorcinol",
    "casNumber": "108-46-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u201"
  },
  {
    "code": "U203",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Safrole",
    "casNumber": "94-59-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u203"
  },
  {
    "code": "U204",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Selenious acid",
    "casNumber": "7783-00-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u204"
  },
  {
    "code": "U205",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Selenium sulfide",
    "casNumber": "7488-56-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u205"
  },
  {
    "code": "U206",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Streptozotocin",
    "casNumber": "18883-66-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u206"
  },
  {
    "code": "U207",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, 1,2,4,5-tetrachloro-",
    "casNumber": "95-94-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u207"
  },
  {
    "code": "U208",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethane, 1,1,1,2-tetrachloro-",
    "casNumber": "630-20-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u208"
  },
  {
    "code": "U209",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethane, 1,1,2,2-tetrachloro-",
    "casNumber": "79-34-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u209"
  },
  {
    "code": "U210",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethene, tetrachloro-",
    "casNumber": "127-18-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u210"
  },
  {
    "code": "U211",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbon tetrachloride",
    "casNumber": "56-23-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u211"
  },
  {
    "code": "U213",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Furan, tetrahydro-",
    "casNumber": "109-99-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u213"
  },
  {
    "code": "U214",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thallium(I) acetate",
    "casNumber": "563-68-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u214"
  },
  {
    "code": "U215",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thallium(I) carbonate",
    "casNumber": "6533-73-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u215"
  },
  {
    "code": "U216",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thallium(I) chloride",
    "casNumber": "7791-12-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u216"
  },
  {
    "code": "U217",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thallium(I) nitrate",
    "casNumber": "10102-45-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u217"
  },
  {
    "code": "U218",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethanethioamide",
    "casNumber": "62-55-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u218"
  },
  {
    "code": "U219",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thiourea",
    "casNumber": "62-56-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u219"
  },
  {
    "code": "U220",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, methyl-",
    "casNumber": "108-88-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u220"
  },
  {
    "code": "U221",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzenediamine, ar-methyl-",
    "casNumber": "25376-45-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u221"
  },
  {
    "code": "U222",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "o-Toluidine hydrochloride",
    "casNumber": "636-21-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u222"
  },
  {
    "code": "U223",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Toluene diisocyanate",
    "casNumber": "26471-62-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u223"
  },
  {
    "code": "U225",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Bromoform",
    "casNumber": "75-25-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u225"
  },
  {
    "code": "U226",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methyl chloroform",
    "casNumber": "71-55-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u226"
  },
  {
    "code": "U227",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethane, 1,1,2-trichloro-",
    "casNumber": "79-00-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u227"
  },
  {
    "code": "U228",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethene, trichloro-",
    "casNumber": "79-01-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u228"
  },
  {
    "code": "U234",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, 1,3,5-trinitro-",
    "casNumber": "99-35-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u234"
  },
  {
    "code": "U235",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "1-Propanol, 2,3-dibromo-, phosphate (3:1)",
    "casNumber": "126-72-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u235"
  },
  {
    "code": "U236",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Trypan blue",
    "casNumber": "72-57-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u236"
  },
  {
    "code": "U237",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Uracil mustard",
    "casNumber": "66-75-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u237"
  },
  {
    "code": "U238",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbamic acid, ethyl ester",
    "casNumber": "51-79-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u238"
  },
  {
    "code": "U239",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benzene, dimethyl-",
    "casNumber": "1330-20-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u239"
  },
  {
    "code": "U240",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Acetic acid, (2,4-dichlorophenoxy)-, salts & esters",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u240"
  },
  {
    "code": "U243",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Hexachloropropene",
    "casNumber": "1888-71-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u243"
  },
  {
    "code": "U244",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thiram",
    "casNumber": "137-26-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u244"
  },
  {
    "code": "U246",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Cyanogen bromide (CN)Br",
    "casNumber": "506-68-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u246"
  },
  {
    "code": "U247",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Methoxychlor",
    "casNumber": "72-43-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u247"
  },
  {
    "code": "U248",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "2H-1-Benzopyran-2-one, 4-hydroxy-3-(3-oxo-1-phenyl-butyl)-, & salts, when present at concentrations of 0.3% or less",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u248"
  },
  {
    "code": "U249",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Zinc phosphide Zn 3 P 2 , when present at concentrations of 10% or less",
    "casNumber": "1314-84-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u249"
  },
  {
    "code": "U271",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Benomyl.",
    "casNumber": "17804-35-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u271"
  },
  {
    "code": "U278",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Bendiocarb.",
    "casNumber": "22781-23-3",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u278"
  },
  {
    "code": "U279",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbaryl.",
    "casNumber": "63-25-2",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u279"
  },
  {
    "code": "U280",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Barban.",
    "casNumber": "101-27-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u280"
  },
  {
    "code": "U328",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "o-Toluidine",
    "casNumber": "95-53-4",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u328"
  },
  {
    "code": "U353",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "p-Toluidine",
    "casNumber": "106-49-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u353"
  },
  {
    "code": "U359",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethylene glycol monoethyl ether",
    "casNumber": "110-80-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u359"
  },
  {
    "code": "U364",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Bendiocarb phenol.",
    "casNumber": "22961-82-6",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u364"
  },
  {
    "code": "U367",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbofuran phenol.",
    "casNumber": "1563-38-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u367"
  },
  {
    "code": "U372",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbendazim.",
    "casNumber": "10605-21-7",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u372"
  },
  {
    "code": "U373",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Propham.",
    "casNumber": "122-42-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u373"
  },
  {
    "code": "U387",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Carbamothioic acid, dipropyl-, S-(phenylmethyl) ester.",
    "casNumber": "52888-80-9",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u387"
  },
  {
    "code": "U389",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Triallate.",
    "casNumber": "2303-17-5",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u389"
  },
  {
    "code": "U394",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "A2213.",
    "casNumber": "30558-43-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u394"
  },
  {
    "code": "U395",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Diethylene glycol, dicarbamate.",
    "casNumber": "5952-26-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u395"
  },
  {
    "code": "U404",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethanamine, N,N-diethyl-",
    "casNumber": "121-44-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u404"
  },
  {
    "code": "U409",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Thiophanate-methyl.",
    "casNumber": "23564-05-8",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u409"
  },
  {
    "code": "U410",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Ethanimidothioic acid, N,N′- [thiobis[(methylimino)carbonyloxy]]bis-, dimethyl ester",
    "casNumber": "59669-26-0",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u410"
  },
  {
    "code": "U411",
    "list": "U",
    "hazardBasis": "listed-toxic",
    "description": "Propoxur.",
    "casNumber": "114-26-1",
    "sourceUrl": "https://www.ecfr.gov/current/title-40/chapter-I/subchapter-I/part-261/subpart-D/section-261.33",
    "codeSlug": "u411"
  }
];
